import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';
import { ClassNameMap } from '@mui/material';

export const useProviderItemGrid = makeStyles<{ classes?: Partial<ClassNameMap<'root'>> }>()(theme => ({
  accepts: {
    gridArea: '1 / 2 / 2 / 3',
    [theme.breakpoints.up('sm')]: {
      gridArea: '1 / 5 / 2 / 6',
    }
  },
  avatar: {
    gridArea: '1 / 1 / 2 / 2',
    [theme.breakpoints.up('sm')]: {
      gridArea: '1 / 1 / 4 / 2',
    }
  },
  bio: {
    gridArea: '3 / 1 / 4 / 3',
    [theme.breakpoints.up('sm')]: {
      gridArea: '2 / 2 / 3 / 6',
    }
  },
  grid: {
    boxSizing: 'border-box',
    display: 'grid',
    gridRowGap: theme.spacing(1),
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: '1fr 51px 1fr 1fr 40px',
    [theme.breakpoints.up('sm')]: {
      gridColumnGap: theme.spacing(3),
      gridRowGap: theme.spacing(2),
      gridTemplateColumns: 'repeat(5, 1fr)',
      gridTemplateRows: '1fr 2fr 1fr',
      maxHeight: '246px',
    }
  },
  nextAvailable: {
    backgroundColor: theme.palette.grey[100],
    gridArea: '5 / 1 / 6 / 3',
    padding: theme.spacing(1, 3),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    padding: theme.spacing(3, 2),
    '&:active': {
      background: grey[50],
    },
    [theme.breakpoints.up('sm')]: {
      border: `1px solid ${theme.palette.divider}`,
      '&:not(:first-of-type)': {
        marginTop: theme.spacing(4),
      },
      maxHeight: '294px',
      padding: theme.spacing(3),
      '&:hover': {
        cursor: 'pointer',
        boxShadow: theme.shadows[3],
        transition: theme.transitions.create('box-shadow', { duration: 200 }),
      },
    }
  },
  specialties: {
    gridArea: '4 / 1 / 5 / 3',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    marginTop: theme.spacing(1),
    whiteSpace: 'pre-line',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      gridArea: '3 / 2 / 4 / 6',
    },
  },
  title: {
    gridArea: '2 / 1 / 3 / 3',
    [theme.breakpoints.up('sm')]: {
      gridArea: '1 / 2 / 2 / 5',
    }
  }
}));

export const useProviderAvatarStyles = makeStyles()(theme => ({
  date: {
    color: theme.palette.text.primary,
    fontWeight: 700
  },
  image: {
    display: 'block',
    height: '72px',
    width: '72px',
    [theme.breakpoints.up('sm')]: {
      height: '180px',
      width: '180px',
    }
  },
  nextAvailable: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.palette.primaryBackground.main,
      display: 'block',
      padding: theme.spacing(1),
      textAlign: 'center',
    }
  },
  root: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      height: '246px',
      width: '180px',
    }
  }
}));

export const useProviderHeaderStyles = makeStyles()(theme => ({
  name: {
    color: theme.palette.darkSlate.main,
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '133.4%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  topLine: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  }
}));

const MAX_LINES_DESKTOP = 4;
const MAX_LINES_MOBILE = 3;

export const useProviderItemStyles = makeStyles()((theme) => ({
  bio: {
    fontSize: '18px',
    lineHeight: '1.5',

    // line clamping
    display: '-webkit-box',
    overflow: 'hidden',
    '-webkit-line-clamp': MAX_LINES_MOBILE.toString(),
    '-webkit-box-orient': 'vertical',
    [theme.breakpoints.up('sm')]: {
      '-webkit-line-clamp': MAX_LINES_DESKTOP.toString(),
    }
  },
  specialties: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
  },
}));
